import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, SmallDateFormat } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckUsernameEmployeeAuth, ApiCreateEmployeeLocation, ApiDeleteEmployeeLocation, ApiGetEmployeeAuthById, ApiGetEmployeeLocationList, ApiGetEmployeeLocationOptions, ApiInsertEmployeeAuth, ApiUpdateEmployeAuth } from "utils/constants/api";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers";
import moment from "moment";
import TrashIcon from "assets/icon/TrashIcon";
import PlusIcon from "assets/icon/PlusIcon";

export default function EmployeeAccess(){
    let navigate = useNavigate()

    const { fetch: getEmployeeAuthById } = useFetch(ApiGetEmployeeAuthById)
    const { fetch: createEmployeeAuth } = useFetch(ApiInsertEmployeeAuth)
    const { fetch: updateEmployeeAuth } = useFetch(ApiUpdateEmployeAuth)
    const { fetch: getEmployeeLocation, data: employeeLocationList } = useFetch(ApiGetEmployeeLocationList)
    const { fetch: createEmployeeLocation } = useFetch(ApiCreateEmployeeLocation)
    const { fetch: deleteEmployeeLocation } = useFetch(ApiDeleteEmployeeLocation)
    const { fetch: getLocation } = useFetch(ApiGetEmployeeLocationOptions)
    const { fetch: apiCheckUsername } = useFetch(ApiCheckUsernameEmployeeAuth)
    
    let queryString = new URLSearchParams(window.location.search)
    let paramEmployeeId = queryString.get("employeeId")
    let paramEmployeeName = queryString.get("employeeName")

    const [username, setUsername] = useState(EmptyString)
    const [password, setPassword] = useState(EmptyString)    
    const [confirmPassword, setConfirmPassword] = useState(EmptyString)
    const [formType, setFormType] = useState(EmptyString)
    const [employeeAuthId, setEmployeeAuthId] = useState(EmptyString)
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false)

    const [employeeName, setEmployeeName] = useState(EmptyString)
    const [location, setLocation] = useState(EmptyString)
    const [locationOptions, setLocationOptions] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const employeeNameChange = (e) => {setEmployeeName(e.target.value)}
    const locationChange = (e) => {setLocation(e.value)}
    const usernameChange = (e) => {setUsername(e.target.value)}
    const passwordChange = (e) => {setPassword(e.target.value)}
    const confirmPasswordChange = (e) => {setConfirmPassword(e.target.value)}

    const [errorUsername, setErrorUsername] = useState(false)
    const [errorPassword, setErrorPassword] = useState(false)
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false)
    const [errorConfirmPasswordMessage, setErrorConfirmPasswordMessage] = useState(EmptyString)
    const [errorUsernameMessage, setErrorUsernameMessage] = useState('Username is required!')
    
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })
    
    const saveBtnClick = () => {
        if(fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})
                if (formType === FormTypeAdd){
                    fInsertEmployeeAuth().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateEmployeeAuth().then(() => {
                        setLoading({isOpen: false})
                    })
                }
                
            }}})
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    const addLocationBtnClick = () => {
        setLoading({isOpen: true})

        fInsertEmployeeLocation().then(() => {
            fGetEmployeeLocationList().then(() => {
                fGetLocationList().then(() => {
                    setLoading({isOpen: false})
                })
            })
        })
    }
    const deleteEmployeeLocationBtnClick = (id) => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fDeleteEmployeeLocation(id).then(() => {
                fGetEmployeeLocationList().then(() => {
                    fGetLocationList().then(() => {
                        setLoading({isOpen: false})
                    })
                })
            })
        }}})
    }

    useEffect(() => {
        setLoading({isOpen: true})

        fGetEmployeeAuthById().then(() => {
            fGetEmployeeLocationList()
            fGetLocationList().then(() => {
                setLoading({isOpen: false})
            })
        })
    }, [])

    // Function Api Call
    async function fGetEmployeeAuthById(){
        await getEmployeeAuthById({
            data: {
                employeeId: paramEmployeeId
            }
        }).then((response) => {
            if (checkResponse(response)){
                let data = response.data

                if (data !== null){
                    setFormType(FormTypeEdit)
                    setEmployeeAuthId(data.employeeAuthId)
                    setEmployeeName(data.employeeName)
                    setUsername(data.username)
                    setStatus(data.status)
                    setCreateDate(moment(data.createDate).format(SmallDateFormat))
                    setUpdateDate(moment(data.updateDate).format(SmallDateFormat))
                    setUpdateBy(data.updateBy)
                }else{
                    setFormType(FormTypeAdd)
                    setEmployeeName(paramEmployeeName)
                }
            }
        })
    }
    async function fInsertEmployeeAuth(){
        await createEmployeeAuth({
            data: {
                employeeId: paramEmployeeId,
                username: username,
                password: password
            }
        }).then((response) => {
            if (checkResponse(response)){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({isOpen: false}) 
                        }
                    } 
                })
            }
        })
    }
    async function fUpdateEmployeeAuth(){
        await updateEmployeeAuth({
            data: {
                employeeAuthId: employeeAuthId,
                username: username,
                password: password
            }
        }).then((response) => {
            if (checkResponse(response)){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({isOpen: false}) 
                        }
                    } 
                })
            }
        })
    }
    async function fInsertEmployeeLocation(){
        await createEmployeeLocation({
            data: {
                employeeId: paramEmployeeId,
                locationId: location
            }
        }).then((response) => {
            checkResponse(response)
        })
    }
    async function fDeleteEmployeeLocation(id){
        await deleteEmployeeLocation({
            data: {
                employeeLocationId: id
            }
        }).then((response) => {
            checkResponse(response)
        })
    }
    async function fGetLocationList(){
        await getLocation({
            data: {
                employeeId: paramEmployeeId
            }
        }).then((response) => {
            if (checkResponse(response)){
                let tempArray = []
                tempArray.push({label: "Select Location", value: ""})

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].locationName, value: String(response.data[i].locationId) })
                }

                setLocationOptions(tempArray)
                setLocation(tempArray[0].value)            
            }
        })
    }
    async function fGetEmployeeLocationList(){
        await getEmployeeLocation({
            data: {
                employeeId: paramEmployeeId
            }
        }).then((response) => {
            checkResponse(response)
        })
    }
    const checkUsername = async() => {
        await apiCheckUsername({
            data: {
                username
            }
        }).then((response) => {
            if (checkResponse(response)) {
                console.log(response)
                if (response.data.duplicate) {
                    setErrorUsernameMessage("Username already taken!")
                    setErrorUsername(true)
                    setIsSaveButtonDisabled(true)
                } else {
                    setErrorUsernameMessage("Username is required!")
                    setErrorUsername(false)
                    setIsSaveButtonDisabled(false)
                }
            }
            
        })
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        // if (formType === FormTypeEdit){
        //     if (userId === EmptyString || userId === null){
        //         setErrorUserId(true)
        //         errorCount++
        //     }else{
        //         setErrorUserId(false)
        //     }
        // }

        // if (username === EmptyString || username === null){
        //     setErrorUsername(true)
        //     errorCount++
        // }else{
        //     setErrorUsername(false)
        // }

        // if (name === EmptyString || name === null){
        //     setErrorName(true)
        //     errorCount++
        // }else{
        //     setErrorName(false)
        // }

        // if (email === EmptyString || email === null){
        //     setErrorEmail(true)
        //     errorCount++
        // }else{
        //     setErrorEmail(false)
        // }

        // if (password === EmptyString || password === null){
        //     setErrorPassword(true)
        //     errorCount++
        // }else{
        //     setErrorPassword(false)
        // }

        // if (confirmPassword === EmptyString || confirmPassword === null){
        //     setErrorConfirmPasswordMessage("Confirm Password is required")
        //     setErrorConfirmPassword(true)
        //     errorCount++
        // }else{
        //     setErrorConfirmPassword(false)
        // }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fHandleConfirmPasswordInput(value){
        if (password !== value){
            setErrorConfirmPasswordMessage("Password did not match!")
            setErrorConfirmPassword(true)
        }else{
            setErrorConfirmPassword(false)
        }
    }

    const checkResponse = (response) => {
        if(response.status === ApiResponseSuccess){
            return true
        }else if(response.status === ApiResponseStatusUnauthorized){
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                        window.location.href = "/login"
                    }
                },
                message: response.message
            })

            return false
        }else{
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: response.message
            })

            return false
        }
    }

    useEffect(() => {
        if (formType === FormTypeAdd){
            checkUsername()
        }       
    }, [username])

    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Employee Access</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="flex flex-col gap-4">
                {/* Employee Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Employee Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={employeeName} onChange={employeeNameChange} maxLength={100} disabled={true} />
                        </div>
                    </div>
                </div>

                {/* Username */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Username</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={username} onChange={usernameChange} maxLength={20} 
                                disabled={formType === FormTypeEdit ? true : false}
                            />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorUsername ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">{errorUsernameMessage}</span>
                    </div>
                </div>

                {/* Password */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Password</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={password} onChange={passwordChange} type="password" />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorPassword ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Password is required!</span>
                    </div>
                </div>

                {/* Confirm Password */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Confirm Password</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={confirmPassword} onChange={confirmPasswordChange} onInput={(e) => { fHandleConfirmPasswordInput(e.target.value) }} type="password" />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorConfirmPassword ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">{errorConfirmPasswordMessage}</span>
                    </div>
                </div>
            </div>

            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} 
                    disabled={isSaveButtonDisabled}
                />
                <BackButton onClick={backBtnClick} />
            </div>

            <div className={`mt-10`}>
                <div>
                    <span className="text-lg font-semibold">Location Assigned</span>
                    <hr />
                </div>
                <div className="mt-5">
                    {/* location */}
                    <div>
                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <div className="w-48">
                                <span>Location</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <Dropdown options={locationOptions} value={location} onChange={locationChange} placeholder={"Select Location"} />
                            </div>
                            <div className="ml-0 sm:ml-4 mt-4 sm:mt-0 w-full sm:w-auto">
                                <button className="flex bg-black text-white px-4 py-2 rounded gap-2 w-full sm:w-auto justify-center" onClick={addLocationBtnClick}>
                                    <PlusIcon />
                                    <span>Add</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-5">
                    <table className="w-full border bg-white">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2">Location</th>
                                <th className="font-semibold w-auto sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            { employeeLocationList?.data?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2">
                                            <span>{ data.locationName }</span>
                                        </td>
                                        <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                            <button className={`button flex gap-2`} onClick={() => deleteEmployeeLocationBtnClick(data.employeeLocationId)}>
                                                <TrashIcon className="w-4 fill-white" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>

            </div>

            

      
            

            

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}